module.exports = __webpack_public_path__ + "img/logowhite.660f8e50.png";